/* Sedanne, comportamento.
   Tres coisas apenas: emergir ao entrar no ecra, inercia muito leve no
   scroll, e adicionar ao carrinho sem sair da pagina.
   Nada aqui rouba o scroll ao browser. */

(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- emergir -------------------------------------------------------- */

  function markReveals() {
    var groups = [
      '.sdn-wrap > .sdn-panel:not(.sdn-hero)',
      '.sdn-shelf > *',
      '.sdn-circles > li',
      '.sdn-duo > *',
      '.sdn-assure > li',
      '.product-grid__item'
    ];
    groups.forEach(function (sel) {
      var nodes = document.querySelectorAll(sel);
      for (var i = 0; i < nodes.length; i++) {
        if (nodes[i].hasAttribute('data-sdn-reveal')) continue;
        nodes[i].setAttribute('data-sdn-reveal', '');
        nodes[i].style.setProperty('--sdn-i', String(i % 8));
      }
    });
  }

  function watchReveals() {
    var targets = document.querySelectorAll('[data-sdn-reveal]:not(.is-in)');
    if (!targets.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      for (var i = 0; i < targets.length; i++) targets[i].classList.add('is-in');
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.04 });
    for (var j = 0; j < targets.length; j++) io.observe(targets[j]);
  }

  /* ---- inercia muito leve --------------------------------------------- */

  var parallaxNodes = [];
  var ticking = false;

  function collectParallax() {
    parallaxNodes = [].slice.call(document.querySelectorAll('[data-sdn-par]'));
  }

  /* Em telemovel o tecto desce para 5px, e o busto deixa de crescer.
     Razao, medida no ecra de 375x812: o heroi tem 10px de folga entre o
     cartao de texto e os cartoes flutuantes, e 12px entre esses e o busto.
     Com o tecto de 36px, e de 70px no busto, o cartao descia 6px, os cartoes
     subiam 5px e o busto subia 30px, ou seja a inercia sozinha comia as duas
     folgas e os elementos entravam uns nos outros. Em ecra grande ha espaco
     para o efeito, em telemovel nao ha. */
  function runParallax() {
    ticking = false;
    var h = window.innerHeight;
    var narrow = window.innerWidth < 750;
    for (var i = 0; i < parallaxNodes.length; i++) {
      var el = parallaxNodes[i];
      var depth = parseFloat(el.getAttribute('data-sdn-par')) || 0.08;
      var r = el.getBoundingClientRect();
      if (r.bottom < -200 || r.top > h + 200) continue;
      var mid = r.top + r.height / 2;
      var raw = (mid - h / 2) * depth * -1;
      var figure = el.classList.contains('sdn-figure');
      var cap = narrow ? 5 : (figure ? 70 : 36);
      if (raw > cap) raw = cap;
      if (raw < -cap) raw = -cap;
      var extra = '';
      if (figure && !narrow) {
        extra = ' scale(' + (1 + raw / 1400).toFixed(4) + ')';
      }
      el.style.transform = 'translate3d(0,' + raw.toFixed(1) + 'px,0)' + extra;
    }
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(runParallax);
  }

  /* ---- aviso em vidro -------------------------------------------------- */

  var toast, toastTimer;

  function showToast(html) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'sdn-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.innerHTML = html;
    void toast.offsetWidth;
    toast.classList.add('is-on');
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(function () { toast.classList.remove('is-on'); }, 3600);
  }

  var CHECK = '<svg width=18 height=18 viewBox="0 0 24 24" fill=none stroke=currentColor stroke-width=1.6 stroke-linecap=round stroke-linejoin=round><circle cx=12 cy=12 r=9></circle><path d="M8.5 12.4l2.4 2.4 4.6-4.9"></path></svg>';

  function bubblePulse() {
    var b = document.querySelector('.cart-bubble');
    if (!b) return;
    b.classList.remove('sdn-pulse');
    void b.offsetWidth;
    b.classList.add('sdn-pulse');
  }

  function refreshBubble() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var nodes = document.querySelectorAll('.cart-bubble__text-count, .cart-bubble__text');
        for (var i = 0; i < nodes.length; i++) nodes[i].textContent = String(cart.item_count);
        var bubble = document.querySelector('.cart-bubble');
        if (bubble) bubble.removeAttribute('hidden');
        bubblePulse();
        return cart;
      })
      .catch(function () {});
  }

  /* ---- adicionar ao carrinho ------------------------------------------ */

  function onSubmit(ev) {
    var form = ev.target.closest ? ev.target.closest('form[data-sdn-add]') : null;
    if (!form) return;
    ev.preventDefault();
    var button = form.querySelector('button');
    if (button) button.disabled = true;
    var body = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: body, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) {
          showToast(CHECK + '<span>' + (res.data.description || 'Nao foi possivel adicionar.') + '</span>');
          return;
        }
        var card = form.closest('.sdn-item');
        if (card) { card.classList.remove('sdn-pop'); void card.offsetWidth; card.classList.add('sdn-pop'); }
        showToast(CHECK + '<span>Adicionado ao carrinho. <a href="/cart">Ver carrinho</a></span>');
        return refreshBubble();
      })
      .catch(function () {
        showToast(CHECK + '<span>Nao foi possivel adicionar. Tenta outra vez.</span>');
      })
      .then(function () { if (button) button.disabled = false; });
  }

  /* ---- arranque -------------------------------------------------------- */

  function boot() {
    markReveals();
    watchReveals();
    collectParallax();
    if (!reduce) {
      runParallax();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', function () { collectParallax(); onScroll(); }, { passive: true });
    }
    document.addEventListener('submit', onSubmit);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    markReveals();
    watchReveals();
    collectParallax();
  });
})();
